import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useAppContext } from '../App';

const API = 'https://api.cpms-srlkevcharge.com';

function formatDuration(secs) {
  if (!secs) return '—';
  const h = Math.floor(secs / 3600);
  const m = Math.floor((secs % 3600) / 60);
  const s = secs % 60;
  if (h > 0) return `${h}h ${m}m`;
  if (m > 0) return `${m}m ${s}s`;
  return `${s}s`;
}

function formatDate(d) {
  if (!d) return '—';
  return new Date(d + 'Z').toLocaleString('en-GB', { dateStyle: 'medium', timeStyle: 'short' });
}

export default function SessionsLog() {
  const [sessions, setSessions] = useState([]);
  const [loading, setLoading]   = useState(true);
  const [filter, setFilter]     = useState('');
  const { liveEvents }          = useAppContext();

  const fetchSessions = async () => {
    try {
      const res = await axios.get(`${API}/sessions/`);
      setSessions(res.data);
    } catch (e) {
      console.error('Failed to fetch sessions', e);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { fetchSessions(); }, []);
  useEffect(() => { if (liveEvents.length > 0) fetchSessions(); }, [liveEvents]);

  const filtered = sessions.filter(s =>
    !filter ||
    s.charger_name.toLowerCase().includes(filter.toLowerCase()) ||
    s.charger_location.toLowerCase().includes(filter.toLowerCase()) ||
    s.status.toLowerCase().includes(filter.toLowerCase())
  );

  if (loading) return <div className="loading">Loading sessions...</div>;

  return (
    <>
      <div className="page-header">
        <h1>Session Log</h1>
        <p>All charging sessions across the SRLK network</p>
      </div>

      <div className="filters">
        <input
          className="filter-input"
          placeholder="Filter by charger, location or status..."
          value={filter}
          onChange={e => setFilter(e.target.value)}
          style={{ width: 300 }}
        />
        <span style={{ alignSelf: 'center', fontSize: 13, color: 'var(--text-muted)' }}>
          {filtered.length} of {sessions.length} sessions
        </span>
      </div>

      <div className="card">
        <div className="table-wrap">
          {filtered.length === 0 ? (
            <div className="empty-state">
              <h3>{sessions.length === 0 ? 'No sessions yet' : 'No results'}</h3>
              <p>
                {sessions.length === 0
                  ? 'Sessions will appear here once chargers connect and start charging.'
                  : 'Try a different search term.'}
              </p>
            </div>
          ) : (
            <table>
              <thead>
                <tr>
                  <th>#</th>
                  <th>Charger</th>
                  <th>Location</th>
                  <th>Started</th>
                  <th>Ended</th>
                  <th>Duration</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>
                {filtered.map(s => (
                  <tr key={s.id}>
                    <td style={{ fontFamily: 'JetBrains Mono, monospace', fontSize: 12, color: 'var(--text-muted)' }}>#{s.id}</td>
                    <td style={{ fontWeight: 500 }}>{s.charger_name}</td>
                    <td style={{ color: 'var(--text-muted)' }}>{s.charger_location}</td>
                    <td>{formatDate(s.start_time)}</td>
                    <td>{formatDate(s.end_time)}</td>
                    <td>{formatDuration(s.duration_seconds)}</td>
                    <td><span className={`badge badge-${s.status.toLowerCase()}`}>{s.status}</span></td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      </div>
    </>
  );
}
